<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="6" md="8">
        <h1 class="pt-5 mb-2">Airports</h1>
        <ul>
          <li>
            Baltimore Washington International Thurgood Marshall Airport (BWI)
          </li>
          <li>Boston Logan International Airport (BOS)</li>
          <li>Bradley International Airport (BDL)</li>
          <li>Chicago Midway Airport (MDW)</li>
          <li>Chicago O'Hare International Airport (ORD)</li>
          <li>Charlotte Douglas International Airport (CLT)</li>
          <li>Cincinnati/Northern Kentucky International Airport (CVG)</li>
          <li>Cleveland-Hopkins International Airport (CLE)</li>
          <li>Dallas Fort Worth International Airport (DFW)</li>
          <li>Denver International Airport (DEN)</li>
          <li>Detroit Metro Wayne County Airport (DTW)</li>
          <li>Fort Lauderdale/Hollywood Airport (FLL)</li>
          <li>General Mitchell International Airport (MKE)</li>
          <li>George Bush Houston Intercontinental Airport (IAH)</li>
          <li>Hartsfield Jackson Atlanta International Airport (ATL)</li>
          <li>Honolulu International Airport (HNL)</li>
          <li>John F. Kennedy International Airport (JFK)</li>
          <li>John Wayne — Orange County Airport (SNA)</li>
          <li>Kansas City Airport (MCI)</li>
          <li>LaGuardia Airport (LGA)</li>
          <li>Lambert St. Louis International Airport (STL)</li>
          <li>Las Vegas McCarran International Airport (LAS)</li>
          <li>Lewis Armstrong New Orleans International Airport (MSY)</li>
          <li>Los Angeles International Airport (LAX)</li>
          <li>Louisville International Airport at Standiford Field (SDF)</li>
          <li>Memphis International Airport (MEM)</li>
          <li>Miami International Airport (MIA)</li>
          <li>Minneapolis St. Paul International Airport (MSP)</li>
          <li>Newark International Airport (EWK)</li>
          <li>Orlando International Airport (MCO)</li>
          <li>Philadelphia International Airport (PHL)</li>
          <li>Phoenix Sky Harbor International Airport (PHX)</li>
          <li>Pittsburgh International Airport (PIT)</li>
          <li>Ronald Reagan Washington National Airport (DCA)</li>
          <li>San Diego International Airport (SAN)</li>
          <li>Salt Lake City International Airport (SLC)</li>
          <li>San Francisco International Airport (SFO)</li>
          <li>Seattle Tacoma International Airport (SEA)</li>
          <li>Theodore Francis Green State Airport (PVD)</li>
          <li>Washington Dulles International Airport (IAD)</li>
          <li>William P. Hobby Houston Airport (HOU)</li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        Airports may be added and removed from time to time. Airports may not be
        available at some times, including when the third party’s surface
        surveillance system is not operating due to planned or unplanned
        outages.
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import UsesNotifications from '@/mixins/UsesNotifications'

export default {
  mixins: [UsesNotifications],
  layout: 'landing',
  mounted() {
    this.showAppDeprecated()
  }
}
</script>
